import { DefaultProps } from '@app/Types/global.interfaces';
import { useAppDispatch } from '@app/redux/hooks';

import { Button } from '@app/shared';
import { ButtonTypeProps } from '@app/shared/ui/ui-kit/Button/TypeProps';

import { fastOrderActions } from '../../module/slice/fastOrderSlice';
import { ProductType, TypeTemplateFastOrder } from '../../module/types/fastOrderSchema';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';

interface ButtonFastOrderProps extends DefaultProps, ButtonTypeProps {
  productData?: ProductType;
  currentShopId?: number;
  template: TypeTemplateFastOrder;
  isProductsIsBasket?: boolean;
  ecommerceLabel?: string;
  ecommerceScenario?: string;
}

export const ButtonFastOrder = ({
  template,
  productData,
  currentShopId,
  isProductsIsBasket,
  children,
  ecommerceLabel,
  ecommerceScenario,
  ...props
}: ButtonFastOrderProps) => {
  const dispatch = useAppDispatch();

  const handlerOpenModal = () => {
    ServiceEcommerce2.setScenario(ecommerceScenario || (currentShopId ? 'Сценарий 3' : 'Сценарий 2'));
    ServiceEcommerce2.scenario(ecommerceLabel);

    dispatch(
      fastOrderActions.setOpenModal({
        productData,
        template,
        currentShopId,
        isProductsIsBasket,
      }),
    );
  };

  return (
    <Button fullWith onClick={handlerOpenModal} {...props} data-testid="button-fast-order">
      {children}
    </Button>
  );
};
